module.exports = __webpack_public_path__ + "img/47.bc92d1de.jpg";